<template>
  <div :style="style">
    <div class="upcoming-content">
      <div class="step center-aligned">
        <img
          class="correct"
          src="/official_mobile/static/img/events/activate/3/correct.png"
        >
        <p class="tips">
          {{ $t('ppwc.p50') }}
        </p>
        <div class="content">
          <img
            class="correct"
            src="/official_mobile/static/img/events/activate/3/talk.png"
          >
          <div class="contact">
            <p><strong>{{ $t('ppwc.p51') }}</strong></p>
            <p style="margin-bottom: 14px;">
              {{ $t('ppwc.p52') | format }} <a
                class="primary_color"
                place="link"
                href="mailto:info@pppoker.net"
              >
                info@pppoker.net
              </a>
            </p>
            <p><strong>{{ $t('ppwc.p53') }}</strong></p>
            <p>
              {{ $t('ppwc.p54') | format }} <a
                class="primary_color"
                place="link"
                href="mailto:events@pppoker.net"
              >
                events@pppoker.net
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    format: function(val) {
      return val.replace('{link}', '')
    }
  },
  data() {
    return {
      style: {}
    }
  },
  mounted() {
    let height = document.documentElement.scrollHeight || document.body.scrollHeight
    let minHeight = height - document.querySelector('.header').offsetHeight - document.querySelector('.slider-tabbar').offsetHeight
    this.style = {
      minHeight: minHeight + 'px'
    }
  },
  created() {
    this.$store.commit('changeTab', 1)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.upcoming-content {
  padding: 40px 24px 60px 24px;
  font-size: 28px;
  line-height: 26px;
}
.step {
  padding-top: 20px;
  .tips {
    margin: 15px 0px;
    font-size: 40px;
    line-height: 50px;
    font-weight: bold;
  }
  .content {
    padding: 30px 0px;
  }
  .correct {
    display: inline-block;
    vertical-align: middle;
    width: 110px;
  }
  .contact {
    margin-top: 20px;
    text-align: center;
    p {
      font-size: 28px;
    }
    a {
      // text-decoration: underline!important;
      box-shadow: 0 1PX;
    }
  }
}
</style>
